module.exports = __webpack_public_path__ + "static/media/pic5@2x.f5f4d21d.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_147/img/pic5@2x.png
// module id = 1417
// module chunks = 0